import { render, staticRenderFns } from "./research-table.vue?vue&type=template&id=4bb54892&scoped=true"
import script from "./research-table.vue?vue&type=script&lang=js"
export * from "./research-table.vue?vue&type=script&lang=js"
import style0 from "./research-table.vue?vue&type=style&index=0&id=4bb54892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb54892",
  null
  
)

/* custom blocks */
import block0 from "@/locale/patient-localization.json?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CUsers%5Cnikod%5CDocuments%5Cgithub%5Cnikodz%5CWebmed.Core.VueJS%5Csrc%5Ccomponent%5Cpatient-history%5Cresearch-table.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locale/kadr-localization.json?vue&type=custom&index=1&blockType=i18n&issuerPath=C%3A%5CUsers%5Cnikod%5CDocuments%5Cgithub%5Cnikodz%5CWebmed.Core.VueJS%5Csrc%5Ccomponent%5Cpatient-history%5Cresearch-table.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports